module.exports = __webpack_public_path__ + "static/img/2_4_2.638ad54c.png";